// NOM-035 — Datos demo completos con cuestionarios contestados

// Use stable IDs so data references work
const tPlanta = Array.from({ length: 12 }, (_, i) => ({
  id: `tp_${i}`,
  numEmpleado: String(i + 1).padStart(3, '0'),
  nombre: ['Juan','María','Carlos','Ana','Pedro','Laura','Roberto','Sofia','Miguel','Elena','José','Patricia'][i],
  apellidoPaterno: ['García','Hernández','Martínez','Rodríguez','Sánchez','Pérez','Gómez','Flores','Torres','Rivera','López','Castillo'][i],
  apellidoMaterno: ['López','Ruiz','Díaz','Torres','Moreno','Jiménez','Ramírez','Vargas','Mendoza','Cruz','Reyes','Ortiz'][i],
  nombreCompleto: ['Juan García López','María Hernández Ruiz','Carlos Martínez Díaz','Ana Rodríguez Torres','Pedro Sánchez Moreno','Laura Pérez Jiménez','Roberto Gómez Ramírez','Sofia Flores Vargas','Miguel Torres Mendoza','Elena Rivera Cruz','José López Reyes','Patricia Castillo Ortiz'][i],
  area: ['Producción','Producción','Calidad','Producción','Mantenimiento','Calidad','Producción','Administración','Producción','Calidad','Producción','Administración'][i],
  puesto: ['Operador','Operadora','Inspector','Operadora','Técnico','Inspectora','Supervisor','Asistente','Operador','Analista','Operador','Auxiliar'][i],
  metodoInvitacion: 'Correo electrónico',
  contacto: `trabajador${i + 1}@novatech.com`,
}));

const tOficina = Array.from({ length: 6 }, (_, i) => ({
  id: `to_${i}`,
  numEmpleado: String(i + 13).padStart(3, '0'),
  nombre: ['Diana','Fernando','Gabriela','Andrés','Verónica','Ricardo'][i],
  apellidoPaterno: ['Morales','Ruiz','Castro','Navarro','Herrera','Delgado'][i],
  apellidoMaterno: ['Vega','Salazar','Luna','Rojas','Campos','Fuentes'][i],
  nombreCompleto: ['Diana Morales Vega','Fernando Ruiz Salazar','Gabriela Castro Luna','Andrés Navarro Rojas','Verónica Herrera Campos','Ricardo Delgado Fuentes'][i],
  area: ['Ventas','Contabilidad','Recursos Humanos','Ventas','Contabilidad','Dirección'][i],
  puesto: ['Ejecutiva','Contador','Coordinadora RH','Vendedor','Auxiliar','Director'][i],
  metodoInvitacion: 'Correo electrónico',
  contacto: `trabajador${i + 13}@novatech.com`,
}));

// ── Generate realistic questionnaire responses ────────────────

// Random int in range
const rand = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

// GI: mostly "No" with occasional events
function genGI(hasEvent = false) {
  const r = {};
  ['g1_1','g1_2','g1_3','g1_4','g1_5','g1_6'].forEach(id => r[id] = hasEvent && Math.random() > 0.6);
  if (Object.values(r).some(v => v)) {
    ['g1_7','g1_8'].forEach(id => r[id] = Math.random() > 0.4);
    ['g1_9','g1_10','g1_11','g1_12','g1_13','g1_14','g1_15'].forEach(id => r[id] = Math.random() > 0.5);
    ['g1_16','g1_17','g1_18','g1_19','g1_20'].forEach(id => r[id] = Math.random() > 0.5);
  } else {
    ['g1_7','g1_8','g1_9','g1_10','g1_11','g1_12','g1_13','g1_14','g1_15','g1_16','g1_17','g1_18','g1_19','g1_20'].forEach(id => r[id] = false);
  }
  return r;
}

// GII: 46 items, likert 0-4, profile determines tendency
function genGII(profile = 'normal') {
  const r = {};
  const base = profile === 'high' ? [2,3,4] : profile === 'low' ? [0,1,2] : [1,2,3];
  for (let i = 1; i <= 46; i++) r[`g2_${i}`] = base[rand(0, 2)];
  // Add filter questions
  r['g2_filtro_clientes'] = Math.random() > 0.4;
  r['g2_filtro_jefe'] = Math.random() > 0.7;
  return r;
}

// GIII: 72 items
function genGIII(profile = 'normal') {
  const r = {};
  const base = profile === 'high' ? [2,3,4] : profile === 'low' ? [0,1,2] : [1,2,3];
  for (let i = 1; i <= 72; i++) r[`g3_${i}`] = base[rand(0, 2)];
  r['g3_filtro_clientes'] = Math.random() > 0.4;
  r['g3_filtro_jefe'] = Math.random() > 0.7;
  return r;
}

// ── Generate fichas ──────────────────────────────────────────

const sexos = ['Masculino','Femenino'];
const edades = ['20 – 24','25 – 29','30 – 34','35 – 39','40 – 44','45 – 49','50 – 54'];
const estadosCivil = ['Soltero(a)','Casado(a)','Unión libre','Divorciado(a)'];
const estudios = ['Secundaria terminada','Preparatoria o bachillerato terminada','Técnico superior terminada','Licenciatura terminada','Licenciatura incompleta'];
const tipoPuestos = ['Operativo','Profesional o técnico','Supervisor','Gerente'];
const contrataciones = ['Tiempo indeterminado','Por tiempo determinado (temporal)'];
const jornadas = ['Fijo diurno (entre las 6:00 y 20:00 hrs)','Fijo nocturno (entre las 20:00 y 6:00 hrs)','Fijo mixto (combinación de nocturno y diurno)'];
const tiempos = ['Menos de 6 meses','Entre 6 meses y 1 año','Entre 1 a 4 años','Entre 5 a 9 años','Entre 10 a 14 años'];
const pick = (arr) => arr[rand(0, arr.length - 1)];

function genFicha(tw) {
  return {
    sexo: pick(sexos),
    edad: pick(edades),
    estadoCivil: pick(estadosCivil),
    nivelEstudios: pick(estudios),
    puesto: tw.puesto,
    area: tw.area,
    tipoPuesto: pick(tipoPuestos),
    tipoContratacion: pick(contrataciones),
    tipoPersonal: pick(['Sindicalizado','Confianza','Ninguno']),
    tipoJornada: pick(jornadas),
    rotacionTurnos: pick(['Sí','No']),
    tiempoPuesto: pick(tiempos),
    tiempoExperiencia: pick(tiempos),
    turno: pick(['Matutino','Vespertino','Mixto']),
  };
}

function genConsentimiento(tw) {
  return {
    fecha: new Date().toISOString(),
    fechaDisplay: new Date().toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }),
    nombreTrabajador: tw.nombreCompleto,
    numEmpleado: tw.numEmpleado,
    archivo: `Consentimiento_${tw.numEmpleado}.pdf`,
    tamano: `${rand(80, 250)} KB`,
    archivoTipo: 'application/pdf',
    // No archivoData in demo to save memory
  };
}

// ── Build complete demo data ─────────────────────────────────

// Planta: 12 workers, all with GI+GIII (nivel 3, >50 trabajadores)
const fichasPlanta = {};
const consentPlanta = {};
const cuestPlanta = {};
const profiles = ['low','low','normal','normal','normal','normal','high','normal','low','normal','high','normal'];

tPlanta.forEach((tw, i) => {
  fichasPlanta[tw.id] = genFicha(tw);
  consentPlanta[tw.id] = genConsentimiento(tw);
  cuestPlanta[`${tw.id}_guiaI`] = genGI(i === 6 || i === 10); // Roberto and José have events
  cuestPlanta[`${tw.id}_guiaIII`] = genGIII(profiles[i]);
});

// Oficina: 6 workers, all with GI+GII (nivel 2, 16-50 trabajadores)
const fichasOficina = {};
const consentOficina = {};
const cuestOficina = {};
const profilesOf = ['normal','low','normal','high','low','normal'];

tOficina.forEach((tw, i) => {
  fichasOficina[tw.id] = genFicha(tw);
  consentOficina[tw.id] = genConsentimiento(tw);
  cuestOficina[`${tw.id}_guiaI`] = genGI(i === 3); // Andrés has events
  cuestOficina[`${tw.id}_guiaII`] = genGII(profilesOf[i]);
});

export const DEMO_DATA = {
  empresa: {
    nombre: 'Grupo Industrial Novatech',
    razonSocial: 'Grupo Industrial Novatech S.A. de C.V.',
    rfc: 'GIN980512AB3',
    actividadEconomica: 'Fabricación de componentes electrónicos',
    representanteLegal: 'Ing. Alejandro Fuentes Navarro',
  },
  politicaData: {
    fechaElaboracion: '2026-01-15',
    nombreRepresentante: 'Ing. Alejandro Fuentes Navarro',
    cargoRepresentante: 'Director General',
    mecanismosQuejas: 'buzón de quejas confidencial, correo rh@novatech.com y línea directa ext. 100',
    compromisosAdicionales: 'Se otorgan días adicionales de descanso por desempeño sobresaliente.',
    version: 1,
    historial: [{ version: 1, fecha: '15 ene 2026, 10:30', autor: 'Ing. Alejandro Fuentes Navarro', descripcionCambio: 'Elaboración inicial de la política' }],
    guardado: true,
  },
  mediosDifusion: [true, true, true, false],
  programaIntervencion: { acciones: [], fechaCreacion: '', responsableGeneral: '' },
  centrosTrabajo: [
    {
      id: 'ct_planta',
      nombreCentro: 'Planta Querétaro',
      numTrabajadores: 65,
      calle: 'Blvd. de las Ciencias',
      numExterior: '1240',
      colonia: 'Parque Industrial Querétaro',
      municipio: 'El Marqués',
      estado: 'Querétaro',
      cp: '76246',
      actividadPrincipal: 'Manufactura de componentes electrónicos y ensamble',
      trabajadores: tPlanta,
      cuestionariosCompletos: cuestPlanta,
      fichas: fichasPlanta,
      consentimientos: consentPlanta,
    },
    {
      id: 'ct_oficina',
      nombreCentro: 'Oficina CDMX',
      numTrabajadores: 22,
      calle: 'Av. Insurgentes Sur',
      numExterior: '1605',
      colonia: 'San José Insurgentes',
      municipio: 'Benito Juárez',
      estado: 'Ciudad de México',
      cp: '03900',
      actividadPrincipal: 'Oficinas administrativas, ventas y dirección corporativa',
      trabajadores: tOficina,
      cuestionariosCompletos: cuestOficina,
      fichas: fichasOficina,
      consentimientos: consentOficina,
    },
  ],
};
